module.exports = __webpack_public_path__ + "static/media/chevron-right-icon.18e0e97e.svg";